import { invokeRPC } from './socket.js'

export function syncWorkbooks() {
  return invokeRPC('tableau', 'syncWorkbooks')
}

export function getProjects() {
  return invokeRPC('tableau', 'getProjects')
}

export function getWorkbook(workbookId) {
  return invokeRPC('tableau', 'getWorkbook', { workbook_id: workbookId })
}

export function getWorkbooks(projectId) {
  return invokeRPC('tableau', 'getWorkbooks', { project_id: projectId })
}

export function getViewsForWorkbook(workbookId) {
  return invokeRPC('tableau', 'getViewsForWorkbook', { workbook_id: workbookId })
}

export function syncViews(projectId) {
  return invokeRPC('tableau', 'syncViews', { project_id: projectId })
}

export function syncTabViewsByWorkbook(workbookId) {
  return invokeRPC('tableau', 'syncViewsForWorkbook', { workbook_id: workbookId })
}

export function getViews(projectId) {
  return invokeRPC('tableau', 'getViews', { project_id: projectId })
}

export function getTicket() {
  return invokeRPC('tableau', 'getTicket')
}

export function getTicketForiFrame() {
  return invokeRPC('tableau', 'getTicketForiFrame')
}

export function getGenerateViewImageToken(data) {
  return invokeRPC('tableau', 'getTokenToGenerateViewImage', data)
}

export function getView(viewId) {
  return invokeRPC('tableau', 'getView', { view_id: viewId })
}

export function getWorkbookViewsByTypeId(id) {
  return invokeRPC('tableau', 'getWorkbookViewsByTypeId', { type_id: id })
}
